import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISimTypeModel } from '@apps-common/types/management/sim-type'

export const MANAGEMENT_QUERY_KEY_SEARCH_SIM_TYPES = (search?: string) => ['searchSimTypes', search].filter(Boolean)

export const searchSimTypes = async (search?: string): Promise<ISimTypeModel[]> =>
  axios.get(`/management/simtype/SearchSimTypes?search=${search || ''}`).then((res) => res.data?.data)

type QueryFnType = typeof searchSimTypes

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
}

export const useManagementSearchSimTypes = ({ config, search }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_SIM_TYPES(search),
    queryFn: () => searchSimTypes(search)
  })
